import { createContext, useContext, useState, useCallback } from "react";
import { RELEASES } from "@/data/catalog";

const PlayerContext = createContext(null);
export const usePlayer = () => useContext(PlayerContext);

export const PlayerProvider = ({ children }) => {
  const [current, setCurrent] = useState(null);
  const [open, setOpen] = useState(false);

  const play = useCallback((track) => {
    setCurrent(track);
    setOpen(true);
  }, []);

  const step = useCallback((dir) => {
    setCurrent((c) => {
      if (!c) return c;
      const i = RELEASES.findIndex((r) => r.ytId === c.ytId);
      const next = (i + dir + RELEASES.length) % RELEASES.length;
      return RELEASES[next];
    });
  }, []);

  return (
    <PlayerContext.Provider value={{ current, open, setOpen, play, next: () => step(1), prev: () => step(-1) }}>
      {children}
    </PlayerContext.Provider>
  );
};
